<app-projects-list
    [projects]="projects"
    [layout]="PROJECT_LIST_LAYOUT.SELECT"
    [columns]="columns"
    [(selectedProjects)]="selectedProjects"
    [clrDgRowSelection]="true"
></app-projects-list>
